import React from "react";

const NewMessageEmail: React.FC = () => {
    const htmlContent = `
        <div class="flex justify-center py-8 bg-gray-100 rounded-lg">
            <div class="max-w-[600px] mx-auto bg-white shadow-lg">
                <div class="bg-gradient-to-r from-blue-600 to-blue-700 px-8 py-6">
                    <h1 class="text-white text-2xl font-semibold">Service Desk</h1>
                </div>
                <div class="px-8 py-6">
                    <h2 class="text-2xl font-semibold text-gray-900 mb-4">You Have a New Message</h2>
                    <p class="text-gray-700 mb-6">There's a new message on your support ticket. Please review the update below.</p>
                    <div class="border-l-4 p-4 mb-4 bg-blue-50 border-blue-200 text-blue-800">
                        <p class="font-semibold mb-1">New Activity on Your Ticket</p>
                        <p class="text-sm">A team member has posted a message on your ticket.</p>
                    </div>
                    <div class="bg-gray-50 p-4 rounded-md mb-6">
                        <div class="flex gap-2 mb-2">
                            <span class="font-semibold text-gray-700 min-w-[120px]">Ticket ID:</span>
                            <span class="text-gray-900"><span class="font-mono text-blue-600">#SD-2024-1547</span></span>
                        </div>
                        <div class="flex gap-2 mb-2">
                            <span class="font-semibold text-gray-700 min-w-[120px]">Subject:</span>
                            <span class="text-gray-900">Unable to access customer database</span>
                        </div>
                        <div class="flex gap-2 mb-2">
                            <span class="font-semibold text-gray-700 min-w-[120px]">Status:</span>
                            <span class="text-gray-900"><span class="inline-block bg-blue-100 text-blue-800 px-2 py-1 rounded text-sm font-medium">In Progress</span></span>
                        </div>
                        <div class="flex gap-2 mb-2">
                            <span class="font-semibold text-gray-700 min-w-[120px]">Assigned To:</span>
                            <span class="text-gray-900">Marcus Chen</span>
                        </div>
                        <div class="flex gap-2 mb-2">
                            <span class="font-semibold text-gray-700 min-w-[120px]">Message Time:</span>
                            <span class="text-gray-900">May 6, 2026 at 3:45 PM</span>
                        </div>
                    </div>
                    <div class="mb-6">
                        <h3 class="font-semibold text-gray-900 mb-2">New Message from Marcus Chen:</h3>
                        <div class="bg-white border border-blue-200 p-4 rounded">
                            <div class="flex items-start gap-3">
                                <div class="flex-shrink-0">
                                    <div class="w-10 h-10 bg-blue-600 text-white rounded-full flex items-center justify-center font-semibold">MC</div>
                                </div>
                                <div class="flex-1">
                                    <div class="flex items-center gap-2 mb-2">
                                        <span class="font-semibold text-gray-900">Marcus Chen</span>
                                        <span class="text-sm text-gray-500">Database Specialist</span>
                                    </div>
                                    <p class="text-gray-700 text-sm">Hi Sarah, I've reviewed your database access issue and identified the root cause. It appears your user account is missing the necessary permissions after last week's security policy update. I've submitted a change request to the DBA team (CR-8472) to grant you the required access. This typically takes 2-4 hours to approve and implement. I'll update you as soon as the permissions are in place. In the meantime, please let me know if you need access to an alternative database environment.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex">
                        <a href="#" class="inline-block bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-md font-medium no-underline transition-colors">View Feedback</a>
                    </div>
                    <div class="mt-6 pt-6 border-t border-gray-200">
                        <p class="text-sm text-gray-600">You can view the complete conversation history and add your own comments through the support portal.</p>
                    </div>
                </div>
                <div class="bg-gray-50 px-8 py-6 border-t border-gray-200">
                    <p class="text-sm text-gray-600">This is an automated message from the Service Desk. Please do not reply directly to this email.</p>
                </div>
            </div>
        </div>
    `;
    return <div dangerouslySetInnerHTML={{ __html: htmlContent }} />;
};

export default NewMessageEmail;
